import React, { useState, useMemo, useRef, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { BreadcrumbComponent } from "../../common/components";
import CustomTabPanel from "../surveys/email-templates/customized-template-tab-panel";
import SupportTicketsList from "./support-tickets-list";
import "./support-ticket-list.scss";

const SupportTicketTabs = () => {
  const [indexValue, setIndexValue] = useState(0);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [hadActiveSearchAndFilters, setHadActiveSearchAndFilters] = useState(false);

  const breadcrumbLink = [
    {
      label: "Support Tickets",
      link: "#",
      handleClick: (event: any) => {
        event.preventDefault();
        setIndexValue(0);
        setViewOpen(false);
      },
    },
  ];
  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setHadActiveSearchAndFilters(false)
    setIndexValue(newValue);
  };


  return (
    <>
      <div className="leadlist-wrapper support-tickets-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
        </div>
        {!viewOpen && (
          <Box className="support-ticket-tabs-wrapper">
            <Tabs
              value={hadActiveSearchAndFilters ? false : indexValue}
              onChange={handleChange}
              allowScrollButtonsMobile
              variant="scrollable"
          >
            <Tab label="On-Going Tickets" />
            <Tab label="Closed Tickets" />
          </Tabs>
          {/* Tab Panels would go here */}
        </Box>)}
        <>
          <CustomTabPanel value={indexValue} index={0} fieldName="afp-support-tickets" viewOpen={viewOpen}>
            <SupportTicketsList
              status="active"
              crumbMappingOption={crumbMappingOption}
              setCrumbMappingOption={setCrumbMappingOption}
              viewOpen={viewOpen}
              setViewOpen={setViewOpen}
              setHadActiveSearchAndFilters={setHadActiveSearchAndFilters}
              hadActiveSearchAndFilters={hadActiveSearchAndFilters}
            />
          </CustomTabPanel>
          <CustomTabPanel value={indexValue} index={1}>
            <SupportTicketsList
              status="closed"
              crumbMappingOption={crumbMappingOption}
              setCrumbMappingOption={setCrumbMappingOption}
              viewOpen={viewOpen}
              setViewOpen={setViewOpen}
              setHadActiveSearchAndFilters={setHadActiveSearchAndFilters}
              hadActiveSearchAndFilters={hadActiveSearchAndFilters}
             
            />
          </CustomTabPanel>
        </>
      </div>
    </>
  );
};

export default SupportTicketTabs;
